// Types
import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

const PlanCancellationReminder = ({ notification }: NotificationSubscriptionProps) => {
    return (
        <Notification
            dataNotification={notification}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.plan_cancellation_reminder.title" />
                <Notification.Description i18nKey="commons:notifications.plan_cancellation_reminder.description" />
            </Notification.Content>
        </Notification>
    );
};

export default PlanCancellationReminder;
